import React from 'react'
import "../styles/subpages.css"
import Navbar from '../components/Navbar/Navbar'
import Footer from '../components/Footer/Footer'
import { useTranslation } from "react-i18next";

const Terms = () => {
const { t } = useTranslation("global");
  return (
    <>
    <Navbar />
    <div className='subpage'>
    <h1>{t("terms.heading")}</h1>
    <p>{t("terms.lastUpdated")}</p>
    <h2>{t("terms.readCarefully")}</h2>
    <h2>{t("terms.interpretationHeading")}</h2>
    <p><strong>{t("terms.interpretation")}</strong></p>
    <p>{t("terms.capitalizedWords")}<br></br> {t("terms.meaningInPlural")}<br></br>{t("terms.definitions")}</p>
    <p>{t("terms.purposes")}</p>
    <ul>
      <li><p>{t("terms.affiliate")}<br></br> {t("terms.ownership")}<br></br> {t("terms.authority")}</p></li>
      <li><p>{t("terms.country")}</p></li>
      <li><p>{t("terms.company")}<br></br> {t("terms.companyAddress")}</p></li>
      <li><p>{t("terms.device")}</p></li>
      <li><p>{t("terms.service")}</p></li>
      <li><p>{t("terms.termsDefinition")}<br></br> {t("terms.entireAgreement")}<br></br> {t("terms.generator")}</p></li>
      <li><p>{t("terms.thirdParty")}<br></br> {t("terms.thirdPartyContent")}</p></li>
      <li><p>{t("terms.website")}</p></li>
      <li><p>{t("terms.you")}</p></li>
    </ul>
    <h2>{t("terms.acknowledgmentHeading")}</h2>
    <p>{t("terms.acknowledgmentContent")}</p>
    <h2>{t("terms.terminationHeading")}</h2>
    <p>{t("terms.terminationContent")}</p>
    <h2>{t("terms.disclaimerHeading")}</h2>
    <p>{t("terms.disclaimerContent")}</p>
    <h2>{t("terms.intellectualPropertyHeading")}</h2>
    <p>{t("terms.intellectualPropertyContent")}</p>
    <h2>{t("terms.governingLawHeading")}</h2>
    <p>{t("terms.governingLawContent")}</p>
    <h2>{t("terms.disputesHeading")}</h2>
    <p>{t("terms.disputesContent")}</p>
    <h2>{t("terms.usComplianceHeading")}</h2>
    <p>{t("terms.usComplianceContent")}</p>
    <h2>{t("terms.severabilityHeading")}</h2>
    <h2>{t("terms.severabilitySubHeading")}</h2>
    <p>{t("terms.severabilityContent")}</p>
    <h2>{t("terms.waiverHeading")}</h2>
    <p>{t("terms.waiverContent")}</p>
    <h2>{t("terms.translationHeading")}</h2>
    <p>{t("terms.translationContent")}</p>
    <h2>{t("terms.changesHeading")}</h2>
    <p>{t("terms.changesContent1")}</p>
    <p>{t("terms.changesContent2")}</p>
    <h2>{t("terms.contactHeading")}</h2>
    <p>{t("terms.contactIntro")}</p>
    <p>{t("terms.contactEmail")}</p>
    </div>
    <Footer />
    </>
  )
}

export default Terms;